
const aboutspan25 = {
    "About Spandana Mar’25": [
        {
          question: "What are the important details of the Bond offering?",
          answer:"Coupon Rate: 10.43% XIRR <br />" + 
          "Coupon Frequency: Quarterly <br />" + 
          "Principal Repayment: 90% at the end of 15 Months and 10% at Maturity <br />" + 
          "ISIN: INE572J07620<br />" + 
          "Debenture Trustee: Catalyst Trusteeship Ltd. <br />" + 
          "Credit Rating: ‘IND A’/ Stable Outlook by India Ratings <br />" + 
          "Listing Details: Bombay Stock Exchange (BSE) <br />" +
          "Coupon : Fixed <br/>" +
          "Original Mode of Issue: Private Placement <br/>" +
          "Date of Issue: 4th Sep, 2023 <br/>"
        },
        {
          question: "What is the Security of the Bond?",
          answer: "The Bond is secured by way of a first ranking, exclusive and continuing charge on identified loan receivables for 1.1x the outstanding amount of the Bond."
        },
        {
          question: "What happens in the case of a downgrade of the Credit Rating?",
          answer: "With each downgrade in the rating of the bond, the coupon of the bond will increase by 0.25% from the date of the downgrade till the date such downgrade exists."
        },
        {
          question: "What are the important covenants that the Issuer has to adhere to?",
          answer: "a. The Capital Adequacy Ratio (Tier 1 and Tier 2 capital) shall not fall below 23% <br />" + 
           "b. GNPA should be less than 8% and NNPA should be less than 5% <br />" + 
           "c. Earnings: PAT (excluding extraordinary Income) to remain positive. <br />" + 
           "b. Promoter i.e. Kedaara Capital should hold atleast 26% in Spandana <br />"
        },
        {
          question: "Can I liquidate the bond before maturity?",
          answer: "Yes, you can liquidate the bond before maturity through our anytime liquidation feature. However, there will be liquidation cost of 2% which will be applied."
        },
        {
          question: "How is the Yield to Maturity (YTM) is calculated?",
          answer: "The Yield to Maturity is calculated using the XIRR formula present in Microsoft Excel or such other spreadsheets. The cash flow is populated in the spreadsheet along with the dates and the XIRR formula is then applied to get the YTM."
        }
      ],
  }
  
  export default aboutspan25;